import { render, staticRenderFns } from "./SubItem.vue?vue&type=template&id=3af14339&ref=container&"
import script from "./SubItem.vue?vue&type=script&lang=js&"
export * from "./SubItem.vue?vue&type=script&lang=js&"
import style0 from "./SubItem.vue?vue&type=style&index=0&id=3af14339&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports